import { render, staticRenderFns } from "./EncuestaMostrarPerfil.vue?vue&type=template&id=72e2f842&scoped=true"
import script from "./EncuestaMostrarPerfil.vue?vue&type=script&lang=js"
export * from "./EncuestaMostrarPerfil.vue?vue&type=script&lang=js"
import style0 from "./EncuestaMostrarPerfil.vue?vue&type=style&index=0&id=72e2f842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2f842",
  null
  
)

export default component.exports